import { KycSection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/styles.ts';
import { ENTITY_TABS } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/types.ts';
import { MantineTabs } from '@dealstack/frontend/shared/components/MantineTabs/MantineTabs.tsx';
import { MantineTabProps } from '@dealstack/frontend/shared/components/MantineTabs/MantineTab.types';
import { Alert, AlertDescription } from '@dealstack/frontend/shared/components/Alert/Alert.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { drawerTransitionProps } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling.tsx';
import { Drawer } from '@mantine/core';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { KycFormsToggleSection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/components/InvestmentWorkflowKycSettingsDrawer/KycFormsToggleSection.tsx';
import { DocumentWorkflowTemplateVisibleIn } from '@dealstack/shared/lib/generated/models/DocumentWorkflowTemplateVisibleIn';

interface Props {
	mipId: string;
	opened: boolean;
	onClose: () => void;
	kycWorkflowId: string | undefined;
}

export const TaxAndComplianceDrawer = ({ mipId, opened, onClose, kycWorkflowId }: Props) => {
	const tMipManage = useTranslationMipManage();
	const { dealId } = useParams<{ dealId?: string }>();
	const [activeTab, setActiveTab] = useState<ENTITY_TABS>(ENTITY_TABS.INDIVIDUAL);

	const tabsConfig: MantineTabProps<ENTITY_TABS>[] = [
		{
			label: tMipManage('kyc_settings.label.individual'),
			value: ENTITY_TABS.INDIVIDUAL,
			icon: 'information',
		},
		{
			label: tMipManage('kyc_settings.label.vehicle'),
			value: ENTITY_TABS.INVESTMENT_VEHICLE,
			icon: 'derived_commuted_structure',
		},
	];

	return (
		<Drawer
			opened={opened}
			onClose={onClose}
			position="right"
			transitionProps={drawerTransitionProps}
			title={tMipManage('investments.drawer.tax_compliance.title')}
			styles={{
				body: {
					height: 'calc(100% - 60px)',
					overflow: 'auto',
				},
			}}
		>
			<KycSection $noPadding $noMaxWidth>
				<Alert icon="information-filled" state="info" size="s">
					<AlertDescription>
						{tMipManage('investments.drawer.tax_compliance.audience_alert')}
					</AlertDescription>
				</Alert>
			</KycSection>

			<MantineTabs
				tabs={tabsConfig}
				panels={[]}
				onlyDividerBorder={true}
				value={activeTab}
				onTabChange={(value) => setActiveTab(value as ENTITY_TABS)}
			>
				<KycSection $noMaxWidth>
					<KycFormsToggleSection
						dealId={dealId ?? ''}
						mipId={mipId}
						kycWorkflowId={kycWorkflowId}
						audience={
							activeTab === ENTITY_TABS.INDIVIDUAL
								? DocumentWorkflowTemplateVisibleIn.KYC_INDIVIDUAL
								: DocumentWorkflowTemplateVisibleIn.KYC_VEHICLE
						}
					/>
				</KycSection>
			</MantineTabs>
		</Drawer>
	);
};
